import React from 'react'
import { Typogaphy } from 'vnetwork-ui'
import { useAppStore } from '@/stores/useAppStore'

interface FormLabelProps {
    label: string
    helpContent?: string
    helpTitle?: string
    required?: boolean
    className?: string
}

const FormLabel: React.FC<FormLabelProps> = ({
    label,
    helpContent,
    helpTitle,
    required = false,
    className = '',
}) => {
    const { showHelp } = useAppStore()

    const handleShowHelp = (e: React.MouseEvent) => {
        e.preventDefault()
        e.stopPropagation()
        if (helpContent) {
            showHelp(helpContent, helpTitle || label)
        }
    }

    return (
        <div className={`flex items-center gap-1 mb-1 ${className}`}>
            <Typogaphy size="small">
                {label}
                {required && <span className="text-red-500 ml-0.5">*</span>}
            </Typogaphy>
            {helpContent && (
                <button
                    type="button"
                    onClick={handleShowHelp}
                    className="p-0.5 hover:bg-gray-100 rounded-full transition-colors"
                    title="Xem hướng dẫn"
                >
                    <svg
                        className="w-4 h-4 text-gray-400 hover:text-primary"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth={2}
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                    </svg>
                </button>
            )}
        </div>
    )
}

export default FormLabel
